import PropTypes from 'prop-types'
import { find, map } from 'lodash'
import { filterPostsByTopicSlug } from '../../lib'
import PostCard from '../post-card'
import classNames from 'classnames'

import css from './pregnancy-week-by-week-view.scss'
import PostTeaserList from '../post-teaser-list'
import { PREGNANCY_WEEK_BY_WEEK_SLUG } from '../../constants'
import { StyledSubHeading } from '../../../components/headings'

const PregnancyWeekByWeekView = ({ posts }) => {
  let weekByWeekPosts = filterPostsByTopicSlug(
    posts,
    PREGNANCY_WEEK_BY_WEEK_SLUG,
    { sortBy: 'title', order: 'asc' }
  )
  let firstTrimesterTeaser =
    "Congratulations, you're pregnant! A lot happens during the first trimester of pregnancy. From pregnancy symptoms to baby's development, here's what to know about the first trimester weeks, from 4 weeks to 12 weeks pregnant."
  let secondTrimesterTeaser =
    "You're in the second trimester of pregnancy! These guides for 13 weeks pregnant to 27 weeks pregnant will help you get ready for this stage of pregnancy. From ultrasounds to development, here's what's happening with you and baby during the second trimester weeks."
  let thirdTrimesterTeaser =
    "It's the third trimester now, and your baby will be here soon. As you prepare, find out what's happening with you and baby during these third trimester weeks. Here's what to know about this pregnancy stage, from contractions to birth."
  let sections = [
    {
      header: 'First Trimester',
      title: 'Weeks 4 - 12',
      entry: find(posts, { slug: 'first-trimester' }),
      teaserText: firstTrimesterTeaser,
      posts: weekByWeekPosts.slice(0, 9),
      style: 'weekByWeekHeader__top',
    },
    {
      header: 'Second Trimester',
      title: 'Weeks 13 - 27',
      entry: find(posts, { slug: 'second-trimester' }),
      teaserText: secondTrimesterTeaser,
      posts: weekByWeekPosts.slice(9, 24),
      style: 'weekByWeekHeader',
    },
    {
      header: 'Third Trimester',
      title: 'Weeks 28 - 42',
      entry: find(posts, { slug: 'third-trimester' }),
      teaserText: thirdTrimesterTeaser,
      posts: weekByWeekPosts.slice(24),
      style: 'weekByWeekHeader',
    },
  ]

  return (
    <div className={css.weekByWeekContainer}>
      {map(sections, (section, i) => (
        <div key={section.title}>
          <StyledSubHeading
            className={classNames(css[section.style], 'clearfix mbm h3')}
          >
            {section.header}
          </StyledSubHeading>
          <hr className="mbl" />
          <PostCard
            cardSize={'medium'}
            className="mbl pbl"
            title={section.title}
            image={section.entry.featuredImage?.url}
            teaserText={section.teaserText}
            slug={section.entry.slug}
          />
          <PostTeaserList posts={section.posts} />
        </div>
      ))}
    </div>
  )
}

PregnancyWeekByWeekView.propTypes = {
  posts: PropTypes.object.isRequired,
}

export default PregnancyWeekByWeekView
